const BUY_IT_AGAIN_BAG_PAGE_CONSTANTS = {
  BUY_IT_AGAIN_BAG_PAGE_FETCH_PRODUCTS: 'BUY_IT_AGAIN_BAG_PAGE_FETCH_PRODUCTS',
  GET_MORE_BIA_BAGPAGE_DRAWER_PRODUCTS: 'GET_MORE_BIA_BAGPAGE_DRAWER_PRODUCTS',
  FETCH_BIA_BAGPAGE_DRAWER_PRODUCTS: 'FETCH_BIA_BAGPAGE_DRAWER_PRODUCTS',
  OPEN_SHOP_ALL_BIA_DRAWER: 'OPEN_SHOP_ALL_BIA_DRAWER',
  SET_BIA_PRODUCTS_AVAILABLE_PRODUCTS:'SET_BIA_PRODUCTS_AVAILABLE_PRODUCTS',
  BUY_IT_AGAIN_INITIAL_API_PRODUCT_COUNT_STATIC: 18,
};

export default BUY_IT_AGAIN_BAG_PAGE_CONSTANTS;
